var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 10 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04 10.15 7.8 5.22a.65.65 0 0 0-.63-.5h-.93A2.7 2.7 0 0 0 4.53 0a2.66 2.66 0 0 0-2.62 2.7c0 .82.36 1.54.92 2.03H1.9c-.3 0-.55.2-.62.5L.02 10.15c-.1.42.2.83.62.83h7.78c.42 0 .73-.41.62-.83Zm-4.5-8.67c.64 0 1.16.55 1.16 1.21 0 .67-.52 1.21-1.17 1.21a1.2 1.2 0 0 1-1.17-1.2c0-.67.52-1.22 1.17-1.22Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortion);
export default ForwardRef;